import { useEffect, useState, useCallback } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Link } from "react-router-dom";
import { Plus } from "@phosphor-icons/react";

export default function Locations() {
  const [locs, setLocs] = useState([]);
  const [name, setName] = useState("");
  const [bay, setBay] = useState("");
  const [sub, setSub] = useState("");

  const load = useCallback(() => api.get("/locations").then((r) => setLocs(r.data)), []);
  useEffect(() => { load(); }, [load]);

  const create = async () => {
    try {
      await api.post("/locations", { name, bay: parseInt(bay, 10) || 0, sublocation: sub });
      setName(""); setBay(""); setSub("");
      load();
      toast.success("Location created");
    } catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <div className="p-4 md:p-6 max-w-4xl">
      <Link to="/admin" className="text-xs text-muted-foreground hover:text-primary">← Admin</Link>
      <div className="my-3">
        <div className="label-tech mb-1">Configuration</div>
        <h1 className="font-display font-black text-3xl md:text-4xl tracking-tight">Locations</h1>
      </div>

      <div className="card-flat border-border p-4 mb-4">
        <div className="label-tech mb-2">New location</div>
        <div className="grid grid-cols-1 md:grid-cols-[1fr_100px_1fr_auto] gap-2">
          <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Name (e.g., Bay 4 - Cooler)" className="h-11 px-3 border border-border bg-background rounded-sm text-sm" />
          <input value={bay} onChange={(e) => setBay(e.target.value)} placeholder="Bay #" type="number" className="h-11 px-3 border border-border bg-background rounded-sm text-sm" />
          <input value={sub} onChange={(e) => setSub(e.target.value)} placeholder="Sublocation" className="h-11 px-3 border border-border bg-background rounded-sm text-sm" />
          <button onClick={create} className="btn-hard h-11 px-4 bg-primary text-primary-foreground font-bold uppercase tracking-widest text-xs rounded-sm hover:bg-orange-600 hover:text-white flex items-center gap-1">
            <Plus size={14} weight="bold" /> Create
          </button>
        </div>
      </div>

      <div className="card-flat border-border overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-muted/60 border-b border-border">
            <tr className="text-left label-tech">
              <th className="px-3 py-2">Name</th>
              <th className="px-3 py-2">Bay</th>
              <th className="px-3 py-2">Sublocation</th>
              <th className="px-3 py-2">QR</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {locs.map((l) => (
              <tr key={l.location_id} className="hover:bg-muted/30">
                <td className="px-3 py-2">{l.name}</td>
                <td className="px-3 py-2 font-mono">{l.bay}</td>
                <td className="px-3 py-2">{l.sublocation}</td>
                <td className="px-3 py-2 font-mono text-xs">{l.qr_value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
